module.exports = flarum.core.compat['utils/withAttr'];